<template>
  <div>
    <b-modal ref="termsDisclosureModal" hide-footer body-class="p-0">
      <terms-disclosure
        @agreed="agreed"
        @dontAgree="dontAgree"
      ></terms-disclosure>
    </b-modal>
    <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
      <b-form role="form" @submit.prevent="handleSubmit(submitSettings)">
        <b-row>
          <b-col class="col-4">
            <b-card class="border shadow-sm d-flex h-100">
              <h3>Payment Reminders</h3>
              <p class="text-muted">
                Send payment plan reminders for upcoming payments.
              </p>
              <b-form-checkbox
                v-model="paymentPlanSettings.paymentPlanReminders"
                switch
                size="lg"
                class="pb-3"
              ></b-form-checkbox>
              <div v-if="paymentPlanSettings.paymentPlanReminders">
                <b-row style="max-width:300px" class="pt-2 pb-3">
                  <b-col>
                    <label class="small">
                      How many days prior?
                    </label>
                    <b-form-select
                      v-model="paymentPlanSettings.paymentPlanReminderDays"
                      :options="membershipPaymentPlanReminderDaysOptions"
                    ></b-form-select
                    ><br />
                  </b-col>
                </b-row>
              </div>

              <h3 class="pt-4">Past Due Balances</h3>
              <p class="text-muted">
                Include past-due amounts when processing upcoming payments.
              </p>
              <b-form-checkbox
                v-model="paymentPlanSettings.paymentPlanDontProcessPastDue"
                switch
                size="lg"
                class="pb-3"
              ></b-form-checkbox>
            </b-card>
          </b-col>
          <b-col class="col-8">
            <b-card class="border shadow-sm" style="margin-bottom: 0;">
              <h3>Payment Plan Agreement</h3>
              <p class="text-muted">
                Set terms and conditions for payment plan authorizations and
                approvals.
              </p>
              <b-form-checkbox
                v-model="hasPaymentPlanLegal"
                @change="setDefaultPaymentPlan"
                switch
                size="lg"
              ></b-form-checkbox>

              <div v-if="hasPaymentPlanLegal">
                <user-template
                  :template="paymentPlanSettings.paymentPlanLegal"
                  :keyItems="paymentPlanSettings.paymentPlanKeyItems"
                  @templateUpdate="updateTemplate"
                ></user-template>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="pt-5">
          <b-col>
            <b-button type="submit" variant="primary"
              >Update Payment Plan Settings</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import TermsDisclosure from "./TermsDisclosure.vue";
import UserTemplate from "@/views/Components/UserTemplate";

export default {
  components: {
    "user-template": UserTemplate,
    "terms-disclosure": TermsDisclosure,
  },
  props: { company: null, bindPaymentPlanSettings: null },
  data() {
    return {
      paymentPlanSettings: {
        paymentPlanReminders: null,
        paymentPlanReminderDays: null,
        paymentPlanTemplateLegal: null,
        paymentPlanKeyItems: [],
      },
      membershipPaymentPlanReminderDaysOptions: [],
      hasPaymentPlanLegal: false,
    };
  },
  async mounted() {
    this.paymentPlanSettings = await this.bindPaymentPlanSettings();

    for (let i = 1; i <= 6; i++) {
      this.membershipPaymentPlanReminderDaysOptions.push({ value: i, text: i });
    }

    this.hasPaymentPlanLegal =
      this.paymentPlanSettings.paymentPlanLegal != null;
  },
  methods: {
    async setDefaultPaymentPlan() {
      if (this.hasPaymentPlanLegal) {
        this.hasPaymentPlanLegal = false;
        this.$refs.termsDisclosureModal.show();
      }
    },
    agreed() {
      this.$refs.termsDisclosureModal.hide();
      this.paymentPlanSettings.paymentPlanLegal = this.paymentPlanSettings.defaultPaymentPlanLegal;
      this.hasPaymentPlanLegal = true;
    },
    dontAgree() {
      this.$refs.termsDisclosureModal.hide();

      this.paymentPlanSettings.paymentPlanLegal = "";
      this.hasPaymentPlanLegal = true;
    },
    updateTemplate(m) {
      this.paymentPlanSettings.paymentPlanLegal = m;
    },

    async submitSettings() {
      if (
        this.hasPaymentPlanLegal &&
        !this.paymentPlanSettings.paymentPlanLegal
      ) {
        this.$emitter.emit("error", "The payment plan template must be set.");

        return;
      }

      if (!this.hasPaymentPlanLegal) {
        this.paymentPlanSettings.paymentPlanLegal = null;
      }

      this.$emit("updatePaymentPlanSettings", this.paymentPlanSettings);
    },
  },
};
</script>

<style></style>
